// JavaScript Document for ANS calculator
document.addEventListener("DOMContentLoaded", () => {
  let copyBtn = document.querySelectorAll('.ans-copy-btn'); 
  if(document.querySelectorAll('.ans-input').length > 0) {
    if (copyBtn.length > 0) {
      copyBtn.forEach((btn) => {
        btn.classList.remove('active')
      });
    }
    document.querySelectorAll('.ans-input').forEach((ansInput) => {
      ansInput.addEventListener("input", (event) => {
        let form = ansInput.closest('.ans-calcForm');
        let formType = form.dataset.type;
        if(formType=='standard'){
          let length = form.querySelector('input[name="length"]').value;
          let width = form.querySelector('input[name="width"]').value;
          let depth = form.querySelector('input[name="depth"]').value/12;	
          var totalyards = ((length*width*depth)/27).toFixed(2);
          totalyards=parseFloat(totalyards);		
          form.querySelector('input[name="total"]').value = totalyards;    
          let plus20 = totalyards;
          
          recOrder = (Math.ceil(plus20 * 4) / 4).toFixed(2);
          form.querySelector('input[name="recommendedOrder"]').value = recOrder;
          return false;
        
        
        }else if(formType=='radius'){
          let diameter = form.querySelector('input[name="diameter"]').value/3;
          let depth = form.querySelector('input[name="depth"]').value/36;
          let radius = diameter/2;
          var area = (radius*radius)*3.14;
          var totalyards = (area*depth).toFixed(2);
          totalyards=parseFloat(totalyards);
          form.querySelector('input[name="total"]').value = totalyards;
          let plus20 = totalyards;
          
          recOrder = (Math.ceil(plus20 * 4) / 4).toFixed(2);
          form.querySelector('input[name="recommendedOrder"]').value = recOrder;
          return false;
      	}
       })
     })
    }
    document.querySelectorAll('.ans-copy-btn').forEach((copy) => {
      copy.addEventListener("click", function() {
        let value = copy.previousElementSibling.value;
		navigator.clipboard.writeText(value);
        if (copyBtn.length > 0) {
          copyBtn.forEach((btn) => {
            btn.classList.remove('active')
          });
        }
		copy.classList.add('active');
      });
    }); 
});
